import { createSelector } from '@ngrx/store';

import { selectCoreState } from '../../reducers';

export const getSelectedTab = createSelector(selectCoreState, state => state.peoplePage.selectedTab);
